export const vendorTypes = {
    DELIVERY_DETAILS: "deliveryDetails",
    BULK: "bulk",
    PRODUCT_INFORMATION: "productInformation",
    CARD_REVERSE: "cardReverse",
    CARRIER: "carrier",
    INSTANT_ISSUE_PACKS: "instantIssuePacks",
    CARD_VENDOR_DETAIL: "cardVendorDetail"
}